import { render } from "./PlaceOrderDialog.vue?vue&type=template&id=19867922&scoped=true"
import script from "./PlaceOrderDialog.vue?vue&type=script&lang=js"
export * from "./PlaceOrderDialog.vue?vue&type=script&lang=js"

import "./PlaceOrderDialog.vue?vue&type=style&index=0&id=19867922&lang=css"
import "./PlaceOrderDialog.vue?vue&type=style&index=1&id=19867922&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19867922"]])

export default __exports__